import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className='footer'>
      <div className='footer-container'>
        <div className='footer-content'>
          {/* Logo, Description & Product Hunt Badge */}
          <div className='footer-section footer-about'>
            <div className='footer-logo'>
              <span className='logo-text'>
                Re<span className='logo-highlight'>post</span>
              </span>
            </div>
            <p className='footer-description'>
              Turn one newsletter into 6 platform posts in 90 seconds
            </p>

            {/* Product Hunt Badge */}
            {/* <a
              href='https://www.producthunt.com/products/repost-2?embed=true&utm_source=badge-featured&utm_medium=badge&utm_campaign=badge-repost-2'
              target='_blank'
              rel='noopener noreferrer'
              className='ph-badge-link'
            >
              <img
                alt='Repost - Stop wasting 4 hours repurposing, Generate 6 posts instantly | Product Hunt'
                width='250'
                height='54'
                src='https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1056064&theme=dark&t=1767166885819'
                className='ph-badge-img'
              />
            </a> */}
          </div>

          {/* Product Links */}
          <div className='footer-section'>
            <h4 className='footer-title'>Product</h4>
            <ul className='footer-links'>
              <li>
                <a href='#video-demo'>Demo</a>
              </li>
              <li>
                <a href='#demo'>How It Works</a>
              </li>
              <li>
                <a href='#signup'>Join Beta</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className='footer-bottom'>
          <p className='footer-copyright'>
            © 2025 Repost. All rights reserved.
          </p>
          {/* <div className='footer-legal'>
            <a href='/privacy'>Privacy Policy</a>
            <a href='/terms'>Terms of Service</a>
          </div> */}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
